import { Component,  OnDestroy,  OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {  Router } from '@angular/router';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { HistoryInventory } from 'app/models2/inventory/history-inventory';
import { InputOrOutputInventory } from 'app/models2/inventory/input-or-output-inventory';
import { NotificationsService } from 'app/services/notifications.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HttpService, MenuBreadCrumb, MessageService, params, SessionService} from 'brainloper-ui';

@Component({
  selector: 'app-inputs-details',
  templateUrl: './inputs-details.component.html',
  styleUrls: ['./inputs-details.component.scss']
})
export class InputsDetailsComponent implements OnInit, OnDestroy {

  public showComboPurchaseOrder:boolean = true
  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Almacén Entradas",
      router: '/almacen/entradas_inventario',
    },
    {
      name: "Detalle",
      current: true
    }
  ]

  private urlCrudHistoryInput: string = `${EndpointDictionary.InventoryInputsHistory.CRUD_INVENT_INPUT_HISTORY_DATA}`;
  public urlGetItemsWarehouse: string = `${EndpointDictionary.Item.ITEM_COMBO_WAREHOUSE}`;
  public minStockData: Array<InputOrOutputInventory> = []

  constructor(
    private message: MessageService,
    public dialog: MatDialog,
    public router: Router,
    public http: HttpService,
    private session: SessionService,
    private notificationService: NotificationsService
  ) {
  }

  async ngOnInit(){
    await this.getResourcesMinStock()
  }

  ngOnDestroy() {
    this.session.setData('minStockData',null)
  }



  async saveInput($event: HistoryInventory) {
    this.message.openLoading("Cargando", "Guardando Entrada")
    let res = await this.http.postDataBody<GenericResponse>(this.urlCrudHistoryInput, $event)
    if (res) {
      if(res.url){
        this.notificationService.deleteNotificationByUrl(res.url)
      }

      if (this.minStockData.length > 0) {
        try {
          this.message.SuccessToast('Notificacion Stock Mínimo')
        } catch (error) {
          this.message.Error('Error', error['message'])
        }
      }
      this.message.closeLoading()
      this.message.SuccessToast("Entradas Inventario guardadas correctamente")
      setTimeout(() => {
        this.router.navigate(['/almacen/entradas_inventario'])
      }, 500);
    }
  }

  async getResourcesMinStock(){
    var minStock = this.session.getData('minStockData')
    if (minStock && minStock.length > 0)  {
      this.minStockData = minStock
      this.showComboPurchaseOrder = false
    }
  }

}

